__turbopack_context__.v({
  "banner": "kWZ4Aq_banner",
  "bottomNote": "kWZ4Aq_bottomNote",
  "bottomNoteBar": "kWZ4Aq_bottomNoteBar",
  "content": "kWZ4Aq_content",
  "heroBuyNowButton": "kWZ4Aq_heroBuyNowButton",
  "overlay": "kWZ4Aq_overlay",
  "section": "kWZ4Aq_section",
  "separator": "kWZ4Aq_separator",
  "stack": "kWZ4Aq_stack",
  "title": "kWZ4Aq_title",
  "visual": "kWZ4Aq_visual",
});
